<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <div class="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
      <div class="mb-6">
        <h1 class="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <h2 class="text-2xl font-semibold text-gray-800 mb-2">Sayfa Bulunamadı</h2>
        <p class="text-gray-600 mb-6">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>
      </div>
      
      <div class="space-y-4">
        <RouterLink 
          to="/" 
          class="block w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors"
        >
          Ana Sayfaya Dön
        </RouterLink>
        
        <RouterLink 
          to="/popular-channels" 
          class="block w-full bg-gray-200 text-gray-800 py-3 px-6 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Popüler Kanalları Gör
        </RouterLink>
      </div>
      
      <div class="mt-8 text-sm text-gray-500">
        <p>Belki aradığınız:</p>
        <ul class="mt-2 space-y-1">
          <li><RouterLink to="/" class="text-blue-600 hover:underline">Ana Sayfa</RouterLink></li>
          <li><RouterLink to="/popular-channels" class="text-blue-600 hover:underline">Popüler Kanallar</RouterLink></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
  // 404 sayfası için SEO meta tags
  document.title = '404 - Sayfa Bulunamadı | Veciz AI'
  
  const metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement
  if (metaDesc) {
    metaDesc.setAttribute('content', 'Aradığınız sayfa bulunamadı. Veciz AI ana sayfasına dönün.')
  }
  
  // Canonical URL'yi ana sayfaya yönlendir
  const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement
  if (canonical) {
    canonical.setAttribute('href', 'https://veciz.ai')
  }
})
</script>
